<div class="dash-container py-30">
  <div class="header mb-30 px-30">
    <h1 style="font-weight: 700; margin-bottom: 8px;">Super Admin Dashboard</h1>
    <p class="subtitle-text-color">System-wide overview and maintenance tasks.</p>
  </div>

  <div class="px-30 mb-30">
    <mat-card class="tasks-card shadow-sm">
      <mat-card-header class="pb-15">
        <mat-card-title style="font-size: 1.25rem; font-weight: 600;">Suggested Tasks</mat-card-title>
        <mat-card-subtitle>Recommended actions for system health and configuration.</mat-card-subtitle>
      </mat-card-header>

      <mat-card-content class="mt-12">
        <div class="suggested-tasks">
          <div class="suggested-tasks-wrapper">

            <!-- Task: Loading Local Terminologies -->
            <div class="suggested-task" (click)="navigateToLocalTerminologies()" [ngClass]="{
                   'complete success': localTerminologyStatus === 'complete',
                   'partial orange-border': localTerminologyStatus === 'partial',
                   'none': localTerminologyStatus === 'none'
                 }">
              <div class="rounded-icon-wrapper me-15">
                <mat-icon>inventory_2</mat-icon>
              </div>
              <div class="me-12 panel-description">
                <strong>Load Local Terminologies</strong>
                <p class="status-text m-0">
                  @if (localTerminologyStatus === 'complete') {
                  3/3 resources loaded.
                  } @else if (localTerminologyStatus === 'partial') {
                  {{loadedResourcesCount}}/{{totalResourcesCount}} loaded.
                  } @else {
                  Not loaded yet.
                  }
                </p>
              </div>
              <mat-icon>chevron_right</mat-icon>
              <div class="after-div">
                <mat-icon>check</mat-icon>
              </div>
            </div>

            <!-- Task: Review Pending Organizations -->
            <div class="suggested-task" (click)="navigateToOrganizations()"
              [ngClass]="{ 'success complete': pendingOrgCount === 0 }">
              <div class="rounded-icon-wrapper me-15">
                <mat-icon>business</mat-icon>
              </div>
              <div class="me-12 panel-description">
                <strong>Review Organizations</strong>
                <p class="status-text m-0">
                  @if (pendingOrgCount > 0) {
                  {{pendingOrgCount}} awaiting review.
                  } @else {
                  All caught up.
                  }
                </p>
              </div>
              <mat-icon>chevron_right</mat-icon>
              <div class="after-div">
                <mat-icon>check</mat-icon>
              </div>
            </div>

            <!-- Task: FHIR Terminology Sync -->
            <div class="suggested-task" (click)="navigateToFhirSync()">
              <div class="rounded-icon-wrapper me-15">
                <mat-icon>sync_alt</mat-icon>
              </div>
              <div class="me-12 panel-description">
                <strong>FHIR Terminology Sync</strong>
                <p class="status-text m-0">Migrate app ValueSets.</p>
              </div>
              <mat-icon>chevron_right</mat-icon>
            </div>

          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Other Metrics/Widgets can go here later -->
  <div class="px-30 metrics-grid">
    <!-- Placeholder for future metrics -->
  </div>
</div>